null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/typelevel/cats/v2.1.0/core/src/main/scala/cats/instances/either.scala